import fillCrudMetadataGaps from '../../fillCrudMetadataGaps';
import authorization from '../../util/authorization';
import type {} from '@niaratech/niara-react-components/lib/controls/typeAugmentation';
export default fillCrudMetadataGaps({
  label: 'Política de Cookies',
  labelPlural: 'Políticas de Cookies',
  name: 'PrivacyRule',
  namePlural: 'PrivacyRules',
  custom_blockRecord: true,
  authorization: authorization('consultant', 'admin'),
  deletable: false,
  dynamoDB: {
    tableName: 'SpearPrivacyRule'
  },
  columns: ['id', 'name', 'enabled'],
  fields: [{
    label: 'Id',
    name: 'id',
    type: 'text',
    updatable: false,
    insertable: false,
    id: true,
    renderColumn: false
  }, {
    name: 'name',
    label: 'Nome',
    type: 'text',
    required: true
  }, {
    name: 'enabled',
    label: 'Ativo',
    default: false,
    required: true,
    type: 'boolean'
  }, {
    name: 'cookiePolicy',
    label: 'Política de cookies',
    type: 'textarray',
    required: true,
    options: [{
      value: 'QUOTATION',
      label: 'Cotação'
    }, {
      value: 'OTA_BUILDER',
      label: 'Motor de Reservas / OTA Builder'
    }, {
      value: 'PAYMENT_LINK',
      label: 'Link de Pagamento'
    }]
  }, {
    name: 'legalDataOrigin',
    label: 'Origem dos dados',
    required: true,
    options: [{
      value: 'TENANT',
      label: 'Instalação'
    }, {
      value: 'CLIENT',
      label: 'Cliente'
    }, {
      value: 'CUSTOM_DEFINED',
      label: 'Personalidado'
    }]
  }, {
    name: 'customDefined_corporateName',
    label: 'Razão social',
    conditionalRequired: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED';
    },
    renderForm: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED' ? this.render(e) : false;
    }
  }, {
    name: 'customDefined_brandName',
    label: 'Nome fantasia',
    conditionalRequired: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED';
    },
    renderForm: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED' ? this.render(e) : false;
    }
  }, {
    name: 'customDefined_vat',
    label: 'CNPJ',
    conditionalRequired: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED';
    },
    renderForm: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED' ? this.render(e) : false;
    }
  }, {
    name: 'customDefined_address',
    label: 'Endereço',
    conditionalRequired: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED';
    },
    renderForm: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED' ? this.render(e) : false;
    }
  }, {
    name: 'customDefined_email',
    label: 'E-mail',
    conditionalRequired: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED';
    },
    renderForm: function (e) {
      return e?.legalDataOrigin == 'CUSTOM_DEFINED' ? this.render(e) : false;
    }
  }],
  filter: [{
    name: 'enabled_eq',
    field: 'enabled',
    op: 'eq'
  }]
});